/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a single customization item in the menu order.
 * @export
 * @interface MenuOrderSubItem
 */
export interface MenuOrderSubItem {
    /**
     * 
     * @type {string}
     * @memberof MenuOrderSubItem
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderSubItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderSubItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderSubItem
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderSubItem
     */
    taxRate: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderSubItem
     */
    notes?: string;
    /**
     * URLs for digital item redemption (one per quantity)
     * @type {Array<string>}
     * @memberof MenuOrderSubItem
     */
    redemptionUrls?: Array<string>;
    /**
     * Tillo references for digital item redemption (one per quantity)
     * @type {Array<string>}
     * @memberof MenuOrderSubItem
     */
    redemptionReferences?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrderSubItem
     */
    requiresShipping?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderSubItem
     */
    fulfillmentType?: string;
    /**
     * 
     * @type {object}
     * @memberof MenuOrderSubItem
     */
    fulfillmentPayload?: object;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderSubItem
     */
    printfulSyncProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderSubItem
     */
    menuCustomizationItemId?: string;
    /**
     * 
     * @type {Array<MenuOrderSubItem>}
     * @memberof MenuOrderSubItem
     */
    customizations?: Array<MenuOrderSubItem>;
}

/**
 * Check if a given object implements the MenuOrderSubItem interface.
 */
export function instanceOfMenuOrderSubItem(value: object): value is MenuOrderSubItem {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    return true;
}

export function MenuOrderSubItemFromJSON(json: any): MenuOrderSubItem {
    return MenuOrderSubItemFromJSONTyped(json, false);
}

export function MenuOrderSubItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderSubItem {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'name': json['name'],
        'price': json['price'],
        'quantity': json['quantity'],
        'taxRate': json['taxRate'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'redemptionUrls': json['redemptionUrls'] == null ? undefined : json['redemptionUrls'],
        'redemptionReferences': json['redemptionReferences'] == null ? undefined : json['redemptionReferences'],
        'requiresShipping': json['requiresShipping'] == null ? undefined : json['requiresShipping'],
        'fulfillmentType': json['fulfillmentType'] == null ? undefined : json['fulfillmentType'],
        'fulfillmentPayload': json['fulfillmentPayload'] == null ? undefined : json['fulfillmentPayload'],
        'printfulSyncProductId': json['printfulSyncProductId'] == null ? undefined : json['printfulSyncProductId'],
        'menuCustomizationItemId': json['menuCustomizationItemId'] == null ? undefined : json['menuCustomizationItemId'],
        'customizations': json['customizations'] == null ? undefined : ((json['customizations'] as Array<any>).map(MenuOrderSubItemFromJSON)),
    };
}

export function MenuOrderSubItemToJSON(json: any): MenuOrderSubItem {
    return MenuOrderSubItemToJSONTyped(json, false);
}

export function MenuOrderSubItemToJSONTyped(value?: MenuOrderSubItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'name': value['name'],
        'price': value['price'],
        'quantity': value['quantity'],
        'taxRate': value['taxRate'],
        'notes': value['notes'],
        'redemptionUrls': value['redemptionUrls'],
        'redemptionReferences': value['redemptionReferences'],
        'requiresShipping': value['requiresShipping'],
        'fulfillmentType': value['fulfillmentType'],
        'fulfillmentPayload': value['fulfillmentPayload'],
        'printfulSyncProductId': value['printfulSyncProductId'],
        'menuCustomizationItemId': value['menuCustomizationItemId'],
        'customizations': value['customizations'] == null ? undefined : ((value['customizations'] as Array<any>).map(MenuOrderSubItemToJSON)),
    };
}

